<template>
  <div id="app">
    <MainHeader v-if="hasToken" />
    <div class="content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" class="router-view"></component>
        </transition>
      </router-view>
    </div>
    <MainFooter />
  </div>
</template>

<script>
import MainFooter from './components/MainFooter.vue';
import MainHeader from './components/MainHeader.vue';
import router from './router';
import axios from 'axios';

export default {
  name: 'App',
  components: {
    MainFooter,
    MainHeader
  },
  data() {
    return {
      hasToken: !!localStorage.getItem('token')
    };
  },
  mounted() { 
    setInterval(async () => {
      const token = localStorage.getItem('token');
      this.hasToken = !!token;
    
      if (!token && router.currentRoute.value.path !== '/') {
        router.push('/');
        return;
      }
    
      if (token && router.currentRoute.value.path.startsWith('/admin')) {
        try {
          await axios.get('/admin/ProtectedRoute', {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });
        } catch (err) {
          if (err.response?.status === 403) {
            localStorage.removeItem('token');
            this.hasToken = false;
            router.push('/login');
          }
        }
      }
    }, 1000); 
  }
};
</script>

